<form [formGroup]="form.formGroup">
  <div class="flex space-x-4">
    <div class="w-1/2 space-y-2">

      <div class="flex flex-col">
        <label>Total Time to Open Choke</label>
        <app-validated-number-input
          class="flex-1 min-w-0"
          [id]="'totalTimeToOpenChoke'"
          [control]="control('totalTimeToOpenChoke')"
          [value]="control('totalTimeToOpenChoke').value"
          (onChange)="updateInitialTimeToOpenValidation()"
          [validation]="{ min: 0, max: 10 }"
          [unit]="'min'"
        ></app-validated-number-input>
      </div>

      <div class="flex flex-col">
        <label>Initial Time to Open Choke</label>
        <app-validated-number-input
          class="flex-1 min-w-0"
          [id]="'initialTimeToOpenChoke'"
          [control]="control('initialTimeToOpenChoke')"
          [value]="control('initialTimeToOpenChoke').value"
          [validation]="{ min: 0, max: form.formGroup.controls.totalTimeToOpenChoke.value }"
          [unit]="'min'"
        ></app-validated-number-input>
      </div>

    </div>

    <div class="w-1/2 space-y-2">

      <div class="flex flex-col">
        <label>Terminal Choke Open/Travel</label>
        <app-validated-number-input
          class="flex-1 min-w-0"
          [id]="'terminalChokeOpenPercent'"
          [control]="control('terminalChokeOpenPercent')"
          [value]="control('terminalChokeOpenPercent').value"
          (onChange)="updateInitialCokeOpenValidation()"
          [validation]="{ min: 0, max: 100 }"
          [unit]="'%'"
        ></app-validated-number-input>
      </div>

      <div class="flex flex-col">
        <label>Initial Choke Open/Travel</label>
        <app-validated-number-input
          class="flex-1 min-w-0"
          [id]="'initialChokeOpenPercent'"
          [control]="control('initialChokeOpenPercent')"
          [value]="control('initialChokeOpenPercent').value"
          [validation]="{ min: 0, max: form.formGroup.controls.terminalChokeOpenPercent.value }"
          [unit]="'%'"
        ></app-validated-number-input>
      </div>

    </div>

  </div>

  @if (false) {
    <div class="flex items-center pt-2">
      <input
      type="checkbox"
      binary="true"
      formControlName="allowTransientFlow"
      >
      <label class="pl-2">Allow Transient Unsteady Flow / Mass Accumulation</label>
    </div>
  }
</form>